import React from 'react';
import { Fragment } from 'react';
import LeftMenu from "../leftmenu";
import './home.css';

class HomeScreen extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            screenName: props.screenName,
            expandedMenu: false
        };
    }

    render() {

        const { expandedMenu } = this.state;

        return (
            <Fragment>
                <div className='navigationBar'>
                    <span className='expandableMenuButtonContainer' onClick={this.expandMenuClickHandler}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                             className="bi bi-list" viewBox="0 0 16 16">
                            <path fillRule="evenodd"
                                  d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5"/>
                        </svg>
                    </span>
                </div>

                <div className="home">
                    <LeftMenu expanded={expandedMenu}/>
                    <div className="contentMainContainer">
                        <div className="contentHeaderTop">

                        </div>
                        <div className="contentHeader">
                            <span>{this.getScreenName()}</span>
                        </div>
                        <div className="contentContainer">
                            <div className="contentMain">
                                {this.renderHomeContent()}
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }

    renderHomeContent() {

    }

    getScreenName() {
        return " _";
    }

    expandMenuClickHandler = () => {
        this.state.expandedMenu = !this.state.expandedMenu;
        this.setState(this.state);
    };
}

export default HomeScreen;


// WEBPACK FOOTER //
// ./src/screens/homescreen/homescreen.js